export default "__VITE_ASSET__c2b6da69__"